import React from 'react';
import { Typography } from '@material-ui/core';

const FieldIdMismatchWarning = ({ show, label }) => {
  if (!show) return null;

  return (
    <Typography variant="caption" className="field-id-warning">
      No matching ID found for <strong className="field-id-warning-value">{label}</strong> -
      please reselect.
    </Typography>
  );
};

export default FieldIdMismatchWarning;
